import { useState } from "react";
import "./loopview.css";
import { X } from "lucide-react";
import rightarrow from "../../Assets/images/rightarrow.png";
import tryagain from "../../Assets/images/repeatagain.svg";
import Aitwin from "../../Assets/images/Frame.png";
import "./loop.css";

const LoopTwobody = ({
  data,
  onQuizComplete,
  onAskTutor,
  tutorName,
  isChatOpen,
}) => {
  const [qIndex, setQIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [score, setScore] = useState(0);
  const [showResult, setShowResult] = useState(false);

  const questions = data.groupedQuestions || [];
  console.log("Loop 2 Data:", data);
console.log("Loop 2 Questions:", data.groupedQuestions);
  const current = questions[qIndex];

  const handleOptionClick = (optionKey) => {
    setSelectedOption(optionKey);

    if (optionKey === current.correctAnswer) {
      setIsCorrect(true);
      setScore((prev) => prev + 1);
    } else {
      setIsCorrect(false);
    }

    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleContinue = () => {
    setShowModal(false);
    setSelectedOption("");

    if (qIndex < questions.length - 1) {
      setQIndex(qIndex + 1);
    } else {
      setShowResult(true);
    }
  };

  const optionColors = ["#FFF5E2", "#E2E9FF", "#F3E2FF", "#FFE7E2"];

  // ✅ RESULT SCREEN (IMPORTANT)
  if (showResult) {
    const percentage = Math.round((score / questions.length) * 100);
    const isPassed = score >= 2;

    return (
      <div className="h-full flex flex-col justify-between">
        <div>
          <h2 className="title text-4xl font-semibold">Your Score</h2>
          <h1 className="title my-4 text-6xl font-semibold">{percentage}%</h1>

          {isPassed ? (
            <p className="bodytext1">
              Great job. You can move on to the next step, or chat with {tutorName} if
              you want a bit more practice or clarity.
            </p>
          ) : (
            <p className="bodytext1">
              You didn’t pass this section yet. Review the questions and try
              again. {tutorName} can help if you want extra support.
            </p>
          )}
        </div>

        {/* ✅ Bottom Button Section */}
        <div className="card-footer mt-4 flex flex-col gap-3 px-2 pb-3">
          {/* ✅ Ask Tutor button */}
          <button
            onClick={onAskTutor}
            className="btn w-100 flex items-center justify-center gap-2 border border-black"
          >
            <img src={Aitwin} alt="icon" className="w-4 h-4 object-contain" />

            {isChatOpen
              ? `Close Chat with ${tutorName}`
              : `Ask ${tutorName} for Help`}
          </button>

          {/* Existing button */}
          {isPassed ? (
            <button
              onClick={() => onQuizComplete(true)}
              className="btn btn-dark w-100 flex items-center justify-center gap-2"
            >
              <span>Continue to Apply</span>
              <img src={rightarrow} className="w-4 h-4" />
            </button>
          ) : (
            <button
              onClick={() => {
                setQIndex(0);
                setScore(0);
                setShowResult(false);
              }}
              className="btn btn-dark w-100 flex items-center justify-center gap-2"
            >
              <span>Try Quiz Again</span>
              <img src={tryagain} className="w-4 h-3" />
            </button>
          )}
        </div>
      </div>
    );
  }

  if (!current) return null;

  return (
    <div className="m-1">
      <h5 className="title">Question {qIndex + 1}</h5>

      <p className="bodytext1">{current.bodytext1}</p>

      <div className="mt-4 flex flex-col gap-3">
        {/* {["A", "B", "C", "D"].map((label, i) => {
          const option = current[`option${i + 1}`];

          return (
            <button
              key={i}
              onClick={() => handleOptionClick(label)}
              className="py-2 rounded-md border border-black text-center transition hover:opacity-80 option-shadow"
              style={{
                backgroundColor: optionColors[i],
                fontFamily: "AvenirNextLTPro-Regular",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              {`Option ${label}`}
            </button>
          );
        })} */}
        {["A", "B", "C", "D"].map((label, i) => {
  const option = current[`option${i + 1}`];

  return (
    <button
      key={i}
      onClick={() => handleOptionClick(label)}
      className="py-2 rounded-md border border-black text-center transition hover:opacity-80 option-shadow"
      style={{
        backgroundColor: optionColors[i],
        fontFamily: "AvenirNextLTPro-Regular",
        fontSize: "13px",
        fontWeight: "600",
      }}
    >
      {option || `Option ${label}`}
    </button>
  );
})}
      </div>

      {/* ✅ MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-[#F5F3EE] rounded-2xl shadow-xl w-[440px] min-h-[500px] relative flex flex-col justify-center items-center text-center p-10">
            {/* <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X size={20} />
            </button> */}

            <div className="flex flex-col items-center justify-center flex-1">
              {isCorrect ? (
                <>
                  <h2 className="text-2xl font-semibold mb-3 text-gray-900">
                    Correct!
                  </h2>

                  <p className="text-gray mb-6 max-w-[90%]">
                    {current.correctAnswerText}
                  </p>

                  <img
                    src={require("../../Assets/images/icons8-bullseye 1.png")}
                    alt="Correct"
                    className="w-24 h-24 mb-6"
                  />

                  <button
                    onClick={handleContinue}
                    className="shodowview bg-black text-white py-2 px-20 rounded-lg mt-6"
                  >
                    Continue
                  </button>
                </>
              ) : (
                <>
                  <h2 className="text-2xl font-semibold mb-3 text-gray-900">
                    Not quite right.
                  </h2>

                  <p className="text-gray mb-6 max-w-[90%]">
                    That's not the best answer. Try again.
                  </p>

                  <img
                    src={require("../../Assets/images/icons8-thinking 2 (1).png")}
                    alt="Wrong"
                    className="w-24 h-24 mb-6"
                  />

                  <button
                    onClick={handleContinue}
                    className="shodowview bg-black text-white py-2 px-20 rounded-lg mt-6"
                  >
                    Continue
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoopTwobody;

{
  /* {data.TitleName.split('\n').map((line, index) => (
          <div key={index} className='title-line'>
            {line}
          </div>
        ))} */
}
